module.exports = __webpack_public_path__ + "img/20250813SelmaFynn-29.868c5c93.jpg";